import { Switch } from '@/components/ui/switch';
import { DebugSection } from '../DebugSection';
import { useDebugLayer } from '../DebugLayerProvider';

/**
 * Aktive Preview-/Operator-Flags — strikt route-gefiltert.
 *
 * Es werden nur Flags gerendert, deren `routeMatcher` zur aktuellen
 * Route passt. Flags ohne Matcher bleiben sichtbar (Backwards-Compat),
 * sollen aber Ausnahmen sein.
 */
export function PreviewFiltersSection() {
  const { routeFlags, setFlag } = useDebugLayer();

  if (routeFlags.length === 0) return null;

  return (
    <DebugSection
      title="Aktive Vorschau / Filter"
      description="Steuert nur die Admin-Vorschau. Normale Nutzer sehen weiterhin ausschliesslich publizierte Daten."
      visible
    >
      {routeFlags.map((f) => (
          <div
            key={f.id}
            className="flex items-start justify-between gap-3 rounded-md border border-border/60 bg-muted/30 px-3 py-2"
          >
            <div className="min-w-0">
              <p className="text-sm font-medium leading-snug">{f.label}</p>
              {f.description ? (
                <p className="text-xs text-muted-foreground mt-0.5">
                  {f.description}
                </p>
              ) : null}
              <p className="text-[10px] uppercase tracking-wide text-muted-foreground/70 mt-1">
                Scope: {f.scope}
              </p>
            </div>
            <Switch
              checked={f.enabled}
              onCheckedChange={(v) => setFlag(f.id, v)}
              aria-label={f.label}
              data-testid={`debug-flag-${f.id}`}
            />
          </div>
        ))}
    </DebugSection>
  );
}
